module.exports = __webpack_public_path__ + "img/security-icon.eabc896f.svg";